import { BubbleChatElement } from '@src/clientUser/bubbleChat/BubbleChat';
import { Language } from '@src/common/i18n/Language';
import { useSelectedLanguage } from '@src/common/i18n/useSelectedLanguage';
import Config from '@src/config/Config';
import { useEffect } from 'react';

export const useBubbleChat = () => {
  const { widgetId } = useChatWidgetId();

  useEffect(() => {
    if (!widgetId) {
      return;
    }

    const existingChatBubble = BubbleChatElement.find();
    if (existingChatBubble) {
      return BubbleChatElement.remove;
    }

    BubbleChatElement.add(widgetId);
    return BubbleChatElement.remove;
  }, [widgetId]);
};

const useChatWidgetId = () => {
  const { selectedLanguage } = useSelectedLanguage();
  return {
    widgetId:
      selectedLanguage === Language.FR
        ? Config.VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_FR
        : Config.VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_EN,
  };
};
